import { api_labelflow, api_labelflow_training } from '../config.jsx';

/**
 * Resolve an image URL handed back by either API into one the browser can load.
 *
 * The APIs return media URLs RELATIVE to their own mount base, e.g.
 *   /api_labelflow/storage/object?path=labelflow%2F...%2Ffoo.jpg
 *
 * Behind the nginx proxy the FE and both APIs share one origin, so that URL is
 * already correct as-is and this function is a no-op. In local development the
 * FE is on :7000 while the APIs are on :7001/:7002, so a root-relative URL would
 * hit the CRA dev server and 404 -- here we re-point it at the origin of the
 * matching API base from config.jsx.
 *
 * Blob/data URLs (freshly picked local files) and already-absolute URLs are
 * returned untouched.
 */
const originOf = (base) => {
  try {
    return /^https?:\/\//i.test(base) ? new URL(base).origin : '';
  } catch {
    return '';
  }
};

export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (/^(https?:|blob:|data:)/i.test(url)) return url;
  if (!url.startsWith('/')) return url;
  const base = url.startsWith('/api_labelflow_training')
    ? api_labelflow_training
    : api_labelflow;
  return originOf(base) + url;
};

export default resolveMediaUrl;
